export enum Placeholder {
  PHONE = '000-000-0000',
  EMAIL = 'example@domain.com',
  DATE = 'mm/dd/yyyy',
  MONTH = 'mm',
  YEAR = 'yyyy',
  ZIP = '00000',
  UNITS = '00',
  VIN = '17 Characters (Digits and Capital Letters)'
}

export enum BinaryAnswer {
  Yes = 'yes',
  No = 'no'
}
